/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useNewClubRegistrationStatusData from '../../state/clubRegistration/newClubRegistrationStatus/UseNewClubRegistrationStatusData';
import useNewClubRegistrationData from '../../state/clubRegistrationNew/forPromiseCalls/UseNewClubRegistrationData';
import useOrganizationTypeData from '../../state/organizationType/UseOrganizationTypeData';
import useNewOfferingTypeData from '@usas/ui-web/state/offeringTypes/forPromiseCalls/UseNewOfferingTypeData';
import useStatesCombobox from '@usas/ui-web/components/comboboxes/statesCombobox/UseStatesCombobox';

import useUsasClubStaffData from '../../state/clubStaff/UseUsasClubStaffData';
import useLegalEntityTypeData from '../../state/legalEntity/UseLegalEntityTypeData';
import useOrganizationStaffData from '../../state/organizationStaff/UseOrganizationStaffData';

import validate from './NewOrganizationRegistrationValidate'

import Constants from '@usas/ui-web/utils/Constants';
import useForm from '@usas/ui-web/utils/UseForm';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import ClubRegistrationConstants from '../clubRegistration/utils/ClubRegistrationConstants';
import { de } from 'date-fns/locale';

const useNewOrganizationRegistration = () => {
  const { newClubRegistrationStatusState, getNewClubRegistrationStatus, clearNewClubRegistrationStatusData } = useNewClubRegistrationStatusData();
  const { clubRegistrationState, setClubRegistrationState, getUsasClub, postNewClubRegistration, putNewClubRegistration } = useNewClubRegistrationData();
  const { organizationTypeState, setOrganizationTypeState, getOrganizationTypes } = useOrganizationTypeData();
  const { legalEntityTypeState, setLegalEntityTypeState, getLegalEntityTypes } = useLegalEntityTypeData();
  const { organizationStaffState, deleteOrganizationStaff } = useOrganizationStaffData();
  const { offeringTypeState, getOfferingTypesForClubRegistration } = useNewOfferingTypeData();
  const { usasClubStaffState, getUsasClubStaff, deleteUsasClubStaff, postUsasClubStaff } = useUsasClubStaffData();
  const { getStateNameById } = useStatesCombobox(false, true, false, false);

  const [state, setState] = useState({ submitButton: '', tryRedirect: false, validStaff: false, showPage: false, isClubCreated: false });

  const {
    handleSubmit,
    updateFormState,
    formState,
    errorState,
    isDirty,
    setIsDirty,
    setFormData,
    resetForm,
    isSubmitting,
    onValueTextPairChanged,
    onFormValueChanged
  } = useForm(getFormInitialState(), submitFormCallback, validate);

  const onSubmitOrganization = (e) => {
    e.preventDefault();

    handleSubmit();
  }

  const getLegalEntityTypesData = () => {
    const getLegalEntityTypePromise = getLegalEntityTypes();

    if (getLegalEntityTypePromise !== null) {
      getLegalEntityTypePromise.then((newState) => {
        if (newState !== null) {
          const items = newState.arrayData.map(x => { return { id: x.legalEntityTypeId, name: x.typeName } });
          items.unshift({ id: Constants.DEFAULT_ID, name: '--' })

          setLegalEntityTypeState({
            ...newState,
            items,
            areItemsLoaded: true
          });
        }
      }).catch((e) => {
        //TODO context error
      });
    }
  }

  function submitFormCallback() {
    let clubCopy = JSON.parse(JSON.stringify(clubRegistrationState));
    const getOfferingTypesForClubRegistrationPromise = getOfferingTypesForClubRegistration(formState.lscId, true);
    if (getOfferingTypesForClubRegistrationPromise !== null) {
      getOfferingTypesForClubRegistrationPromise.then((newState) => {
        if (newState !== null) {
          const offeringInstanceId = newState.arrayData[0].offerings[0].offeringInstanceId;
          const offeringInstanceExpirationDate = newState.arrayData[0].offerings[0].expirationDate;
          const orgUnitId = clubRegistrationState.objData.orgUnitId || Constants.DEFAULT_ID;

          if (orgUnitId === Constants.DEFAULT_ID) {
            const postNewClubRegistrationPromise = postNewClubRegistration(createClubObj());
            if (postNewClubRegistrationPromise !== null) {
              postNewClubRegistrationPromise.then((newState) => {
                if (newState !== null) {
                  const putNewClubRegistrationPromise = putNewClubRegistration(newState.objData.usasClubId, editClubObjForRegType(newState, offeringInstanceId, offeringInstanceExpirationDate));
                  if (putNewClubRegistrationPromise !== null) {
                    putNewClubRegistrationPromise.then((newState) => {
                      if (newState !== null) {
                        let personOrgRoleArray = []
                        const personOrgRoleObj = {
                          orgRoleId: 33, //TODO get this from environment variable
                          orgRoleName: 'Club Administrator',
                          personOrgRoleField: []
                        }

                        personOrgRoleArray.push(personOrgRoleObj);

                        let staffObj = {
                          personId: formState.personId,
                          personOrgRole: personOrgRoleArray
                        };

                        postUsasClubStaff(newState.objData.orgUnitId, 1, staffObj, true);
                      }
                      //TODO state error
                    });
                  }
                }
              }).catch((e) => {
                //TODO state error
              });
            }
          } else {
            //just update the club
            const putNewClubRegistrationPromise = putNewClubRegistration(clubCopy.objData.usasClubId, editClubObjForRegType(clubCopy, offeringInstanceId, offeringInstanceExpirationDate));
            if (putNewClubRegistrationPromise !== null) {
              putNewClubRegistrationPromise.then((newState) => {
                if (newState !== null) {
                  let personOrgRoleArray = []
                  const personOrgRoleObj = {
                    orgRoleId: 33, //TODO get this from environment variable
                    orgRoleName: 'Club Administrator',
                    personOrgRoleField: []
                  }

                  personOrgRoleArray.push(personOrgRoleObj);

                  let staffObj = {
                    personId: formState.personId,
                    personOrgRole: personOrgRoleArray
                  };

                  const orgUnitId =  newState.objData.orgUnitId;
                  if (usasClubStaffState.arrayData.length > 0 &&
                    usasClubStaffState.arrayData[0].personId !== formState.personId) {

                    const deleteOrganizationStaffPromise = deleteOrganizationStaff(usasClubStaffState.arrayData[0].personOrgRole[0].personOrgRoleDurationId);
                    if (deleteOrganizationStaffPromise !== null) {
                      deleteOrganizationStaffPromise.then((newState) => {
                        if (newState !== null) {
                          postUsasClubStaff(orgUnitId, 1, staffObj, true);
                        }
                      }).catch((e) => {
                        //TODO state error
                      });
                    }
                  } else {
                    postUsasClubStaff(orgUnitId, 1, staffObj, true);
                  }
                }
              }).catch((e) => {
                //TODO state error
              });
            }
          }
        }
        //TODO state success
      }).catch((e) => {
        //TODO state error
      });
    }
  }

  const createClubObj = () => {
    const clubObj = {
      clubName: formState.organizationName.trim(),
      clubCode: formState.organizationCode.trim(),
      lscOrgUnitId: formState.lscId,
      clubOwnerTypeId: formState.clubOwnerTypeId,
      businessEntityTypeId: formState.businessEntityTypeId,
      address1: formState.address1.trim(),
      address2: formState.address2.trim(),
      city: formState.city.trim(),
      stateCode: formState.stateCode,
      postalCode: formState.postalCode.trim(),
      numberOfBoardMembers: 0,
      organizationTypeId: formState.organizationTypeId
    }
    return clubObj;
  }

  const editClubObjForRegType = (newState, offeringInstanceId, offeringInstanceExpirationDate) => {

    let clubCopy = JSON.parse(JSON.stringify(newState.objData));


    clubCopy.orgUnit = {
      ...clubCopy.orgUnit,
      orgUnitName: formState.organizationName.trim(),
      orgUnitCode: formState.organizationCode.trim()
    }

    clubCopy.usasClubAddress =
      clubCopy.usasClubAddress.length > 0 ?
        [{
          ...clubCopy.usasClubAddress[0],
          address: {
            ...clubCopy.usasClubAddress[0]?.address,
            address1: formState.address1.trim(),
            address2: formState.address2.trim(),
            city: formState.city.trim(),
            stateCode: formState.stateCode,
            postalCode: formState.postalCode.trim()
          }
        }]
        :
        [{
          address: {
            address1: formState.address1.trim(),
            address2: formState.address2.trim(),
            city: formState.city.trim(),
            stateCode: formState.stateCode,
            postalCode: formState.postalCode.trim(),
            countryCode: 'USA'
          },
          addressName: "Primary",
          isPrimary: true,
          usasClubId: clubCopy.usasClubId,
        }]

    if (clubCopy.usasClubLegalEntities.length === 1) {
      clubCopy.usasClubLegalEntities[0] = {
        ...clubCopy.usasClubLegalEntities[0],
        legalEntityName: formState.legalEntityName.trim(),
        legalEntityTaxId: formState.legalEntityTaxId.trim(),
        legalEntityTypeId: formState.legalEntityTypeId
      };
    }
    //Add
    else {
      clubCopy.usasClubLegalEntities.push({
        usasClubId: clubCopy.usasClubId,
        legalEntityName: formState.legalEntityName.trim(),
        legalEntityTaxId: formState.legalEntityTaxId.trim(),
        legalEntityTypeId: formState.legalEntityTypeId
      });
    }

    clubCopy.organizationTypeId = formState.organizationTypeId;
    clubCopy.status = ClubRegistrationConstants.PENDING_STATUS;

    const currentDate = new Date();
    if (clubCopy.clubRegistrations.length === 0) {

      clubCopy.clubRegistrations = [{
        usasClubId: clubCopy.usasClubId,
        registrationDate: formState.registrationDate !== Constants.BLANK_DATE_STRING ? formState.registrationDate : currentDate,
        isRenewal: false,
        expirationDate: offeringInstanceExpirationDate,
        offeringInstanceId: offeringInstanceId,
        offeringInstance: undefined,
        registrationSignature: formState.registrationSignature.trim().length > 0 ? formState.registrationSignature.trim() : '',
        registrationSignatureDate: formState.registrationDate !== Constants.BLANK_DATE_STRING ? formState.registrationDate : currentDate,
        status: ClubRegistrationConstants.PENDING_STATUS,
        paymentProcessed: false
        // completedByPersonId: null
      }]
    } else if (clubCopy.clubRegistrations.length === 1) {
      clubCopy.clubRegistrations = [{
        ...clubCopy.clubRegistrations[0],
        registrationSignature: formState.registrationSignature.trim().length > 0 ? formState.registrationSignature.trim() : '',
        registrationSignatureDate: formState.registrationDate !== Constants.BLANK_DATE_STRING ? formState.registrationDate : currentDate,
        registrationDate: formState.registrationDate !== Constants.BLANK_DATE_STRING ? formState.registrationDate : currentDate,
        completedByPersonId: null,
        status: ClubRegistrationConstants.PENDING_STATUS
      }]
    }

    return clubCopy;
  }

  const editClubObj = (clubCopy) => {

    clubCopy = {
      ...clubRegistrationState.objData,
      orgUnit: {
        ...clubRegistrationState.objData.orgUnit,
        orgUnitName: formState.organizationName.trim(),
        orgUnitCode: formState.organizationCode.trim()
      },
      usasClubAddress:
        clubRegistrationState.objData.usasClubAddress.length > 0 ?
          [{
            ...clubRegistrationState.objData.usasClubAddress[0],
            address: {
              ...clubRegistrationState.objData.usasClubAddress[0]?.address,
              address1: formState.address1.trim(),
              address2: formState.address2.trim(),
              city: formState.city.trim(),
              stateCode: formState.stateCode,
              postalCode: formState.postalCode.trim()
            }
          }]
          :
          [{
            address: {
              address1: formState.address1.trim(),
              address2: formState.address2.trim(),
              city: formState.city.trim(),
              stateCode: formState.stateCode,
              postalCode: formState.postalCode.trim(),
              countryCode: 'USA'
            },
            addressName: "Primary",
            isPrimary: true,
            usasClubId: clubRegistrationState.objData.usasClubId,
          }]
    }

    if (clubCopy.usasClubLegalEntities.length === 1) {
      clubCopy.usasClubLegalEntities[0] = {
        ...clubCopy.usasClubLegalEntities[0],
        legalEntityName: formState.legalEntityName.trim(),
        legalEntityTaxId: formState.legalEntityTaxId.trim(),
        legalEntityTypeId: formState.legalEntityTypeId
      };
    }
    //Add
    else {
      clubCopy.usasClubLegalEntities.push({
        usasClubId: clubCopy.usasClubId,
        legalEntityName: formState.legalEntityName.trim(),
        legalEntityTaxId: formState.legalEntityTaxId.trim(),
        legalEntityTypeId: formState.legalEntityTypeId
      });
    }

    if (clubCopy.clubRegistrations.length === 1) {
      clubCopy.clubRegistrations = [{
        ...clubCopy.clubRegistrations[0],
        lscname: null,
        clubName: formState.organizationName.trim(),
        lsccode: null,
        clubCode: formState.organizationCode.trim(),
        registrationSignature: formState.registrationSignature.trim().length > 0 ? formState.registrationSignature.trim() : null,
        registrationSignatureDate: formState.registrationDate !== Constants.BLANK_DATE_STRING ? formState.registrationDate : null,
        registrationDate: formState.registrationDate !== Constants.BLANK_DATE_STRING ? formState.registrationDate : null,
        status: ClubRegistrationConstants.PENDING_STATUS
      }]
    }

    return clubCopy;
  }

  useEffect(() => {
    clearNewClubRegistrationStatusData();

    const getOrganizationTypesPromise = getOrganizationTypes();

    if (getOrganizationTypesPromise !== null) {
      getOrganizationTypesPromise.then((newState) => {
        if (newState !== null) {
          const items = newState.arrayData.map(x => { return { id: x.organizationTypeId, name: x.typeName } });
          items.unshift({ id: Constants.DEFAULT_ID, name: '--' })

          setOrganizationTypeState({
            ...newState,
            items,
            areItemsLoaded: true
          });

          getLegalEntityTypesData();
        }
      }).catch((e) => {
        //TODO context error
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (clubRegistrationState.isObjLoaded === false && clubRegistrationState.isObjLoading === false &&
      newClubRegistrationStatusState.isObjLoaded === false &&
      newClubRegistrationStatusState.isObjLoading === false) {
      //uses the personId of the logged in user if 0 is passed in for the personId
      getNewClubRegistrationStatus(0);
    }

    if (clubRegistrationState.isObjLoaded === true && clubRegistrationState.isObjLoading === false) {
      getUsasClubStaff(clubRegistrationState.objData.orgUnit.orgUnitId, 1, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubRegistrationState])

  useEffect(() => {
    if (usasClubStaffState.isArrayLoaded === true &&
      usasClubStaffState.isArrayLoading === false &&
      clubRegistrationState.isObjLoaded === true &&
      clubRegistrationState.isObjLoading === false) {

      getNewClubRegistrationStatus(0);

      let today = formatDate(new Date());
      const staffMemberId = usasClubStaffState.arrayData[0]?.memberId;

      setFormData({
        ...formState,
        organizationName: clubRegistrationState.objData.orgUnit.orgUnitName,
        organizationCode: clubRegistrationState.objData.orgUnit.orgUnitCode,
        lscId: clubRegistrationState.objData.orgUnit.parentOrgUnitId,
        lscName: clubRegistrationState.objData.orgUnit.parentOrgUnitName,
        address1: clubRegistrationState.objData.usasClubAddress[0].address.address1,
        address2: clubRegistrationState.objData.usasClubAddress[0].address.address2,
        city: clubRegistrationState.objData.usasClubAddress[0].address.city,
        stateCode: clubRegistrationState.objData.usasClubAddress && clubRegistrationState.objData.usasClubAddress[0] ? clubRegistrationState.objData.usasClubAddress[0].address.stateCode : '',
        stateName: clubRegistrationState.objData.usasClubAddress && clubRegistrationState.objData.usasClubAddress[0] ? getStateNameById(clubRegistrationState.objData.usasClubAddress[0].address.stateCode) : '',
        postalCode: clubRegistrationState.objData.usasClubAddress[0].address.postalCode,
        organizationTypeId: clubRegistrationState.objData.organizationTypeId,
        organizationTypeName: clubRegistrationState.objData.organizationTypeName,

        usasClubLegalEntityId: clubRegistrationState.objData.usasClubLegalEntities[0]?.usasClubLegalEntityId,
        legalEntityTypeId: clubRegistrationState.objData.usasClubLegalEntities[0]?.legalEntityTypeId,
        legalEntityTypeName: clubRegistrationState.objData.usasClubLegalEntities[0]?.legalEntityTypeName,
        legalEntityName: clubRegistrationState.objData.usasClubLegalEntities[0]?.legalEntityName,
        legalEntityTaxId: clubRegistrationState.objData.usasClubLegalEntities[0]?.legalEntityTaxId,

        memberId: staffMemberId,
        staffLastName: usasClubStaffState.arrayData[0]?.lastName,
        staffFirstName: usasClubStaffState.arrayData[0]?.firstName,
        registrationSignature: clubRegistrationState.objData.clubRegistrations[0]?.registrationSignature !== null ?
          clubRegistrationState.objData.clubRegistrations[0]?.registrationSignature : '',
        registrationDate: clubRegistrationState.objData.clubRegistrations[0]?.registrationDate !== null ?
          formatDate(clubRegistrationState.objData.clubRegistrations[0]?.registrationDate) : today,
        today: today
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usasClubStaffState])

  useEffect(() => {
    if (clubRegistrationState.isObjLoaded === false &&
      clubRegistrationState.isObjLoading === false &&
      newClubRegistrationStatusState.isObjLoaded === true &&
      (newClubRegistrationStatusState.objData.usasClubId !== undefined && newClubRegistrationStatusState.objData.status === "In Progress")) {
      getUsasClub(newClubRegistrationStatusState.objData.usasClubId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newClubRegistrationStatusState])

  return {
    newClubRegistrationStatusState,
    clubRegistrationState,
    formState,
    errorState,
    state,
    organizationTypeState,
    offeringTypeState,
    usasClubStaffState,
    legalEntityTypeState,
    organizationStaffState,
    onValueTextPairChanged,
    onFormValueChanged,
    onSubmitOrganization,
    setFormData
  };

  function getFormInitialState() {
    return {
      usasClubId: Constants.DEFAULT_ID,  //organizations are still saved in UsasClub table
      organizationName: '',
      organizationCode: '',
      lscId: Constants.DEFAULT_ID,
      lscName: '',
      clubOwnerTypeId: 3, //default to club owner type to 'Other', we may end up making nullable
      ownerTypeName: '',
      businessEntityTypeId: 10, //default to 'Unknown', we may end up making nullable
      businessEntityTypeName: '',
      address1: '',
      address2: '',
      city: '',
      stateCode: '',
      stateName: '',
      postalCode: '',
      validatedAddress: null,
      showedAddressSuggestion: false,
      numberOfBoardMembers: 0, //default to 0, we may end up making nullable
      einNumber: '',
      organizationTypeId: Constants.DEFAULT_ID,
      organizationTypeName: '',
      legalEntityTypeId: Constants.DEFAULT_ID,
      legalEntityTypeName: '',
      legalEntityName: '',
      legalEntityTaxId: '',
      personId: '',
      memberId: '',
      staffLastName: '',
      staffFirstName: '',
      registrationSignature: '',
      registrationDate: '',
      today: Constants.BLANK_DATE_STRING
    }
  };
};

export default useNewOrganizationRegistration;